const btns = document.querySelectorAll("[data-btn]");
const modals = document.querySelectorAll('[data-block="modal"]');

if (btns) {
  const asideMenu = document.querySelector('[data-modal="aside"]');
  const modalFreeLesson = document.querySelector('[data-modal="free-lesson"]');

  btns.forEach((btn) => {
    btn.addEventListener("click", () => {
      if (btn.dataset.btn === "burger") {
        openModal(asideMenu);
      }

      if (btn.dataset.btn === "free-lesson") {
        openModal(modalFreeLesson);
      }
    });
  });
}

if (modals) {
  modals.forEach((modal) => {
    modal.addEventListener("click", (e) => {
      const close = e.target.closest('[data-modal="close"]');

      if (close) {
        closeModal(modal);
      }
    });
  });
}

export function openModal(modal) {
  modal.classList.add("open");
  document.body.classList.add("open");
}

export function closeModal(modal) {
  modal.classList.remove("open");
  document.body.classList.remove("open");
}
